<header class="header-tailwind-class">
  <div class="menu-wrapper">
    <span class="material-symbols-outlined menu-icon">menu</span>
    <div class="logo-wrapper">
      <img src="./OCSLA Blanco.png" alt="Logo" class="w-64 h-16">
    </div>
  </div>

  <div class="user-wrapper">
    <img src="./avatar.png" alt="Usuario" class="user-avatar">
    <span class="user-name">Proveedor01</span>
    <span class="material-symbols-outlined dropdown-icon">arrow_drop_down</span>
  </div>
</header>
